import { useEffect, useState } from 'react'
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai'

import Cookies from 'js-cookie'

import Button, { ButtonProps } from 'components/button'

import { COGNITO_GROUP } from 'services/http-client'

type FavouriteButtonProps = {
  isSolid?: boolean
  onToggle?: (isFavorited: boolean) => void
  transparentBg?: boolean
} & ButtonProps

export const testId = 'favouriteButton'

const FavouriteButton = ({ isSolid = false, onToggle, transparentBg = false, ...rest }: FavouriteButtonProps) => {
  // TO-DO: Remove this dirty fix once we have global state management
  const userGroup = Cookies.get(COGNITO_GROUP)

  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    if (userGroup === 'Brand') {
      setHidden(true)
    }
  }, [userGroup])

  return hidden ? null : (
    <Button
      style="favouriteButton"
      data-test-id={testId}
      onClick={(ev) => {
        ev.stopPropagation()
        ev.preventDefault()
        onToggle?.(isSolid)
      }}
      icon={isSolid ? <AiFillHeart fill="#C52626" /> : <AiOutlineHeart />}
      {...rest}
    />
  )
}

export default FavouriteButton
